import 'leaflet-velocity'
import React from 'react'
import PropTypes from 'prop-types'
import { useMap } from 'react-leaflet'
import 'leaflet-timedimension'
import moment from 'moment'

const MapTimeline = ({ onLoad }) => {
    const map = useMap()
    map.timeDimension.on('timeloading', (data) => {
        onLoad(data)
    })
    map.timeDimension.on('timeload', (data) => {
        if (data.time) {
            const date = moment(data.time)
                .add(3, 'hours')
                .format('DD/MM H[hrs]')
            document.querySelector('.timecontrol-date').innerHTML = date
        }
    })

    return <></>
}

export default MapTimeline

MapTimeline.propTypes = {
    onLoad: PropTypes.func,
}
